import React from 'react';
import {parseOperatorWorkMetrics} from '@shared/operator-work-metrics';
import {formatPhoneReportTime,type OperatorPhoneReport} from './operatorDeliveryStatus';

export function OperatorConnection({report}:{report?:OperatorPhoneReport}) {
  const connection=parseOperatorWorkMetrics(report?.workMetrics)?.connection;
  if (!connection || connection.transport==='unknown') return <p className="text-xs text-muted-foreground">Connection: Not reported by phone</p>;
  const parts=[connection.transport==='wifi'?'Wi-Fi':connection.transport==='cellular'?'Mobile data':'No connection'];
  if (connection.transport==='cellular') {
    if(connection.carrier) parts.push(connection.carrier);
    if(connection.generation && connection.generation!=='unknown') parts.push(connection.generation.toUpperCase());
  }
  if(connection.transport==='wifi' && connection.wifiStrength!=null) parts.push(`Wi-Fi strength ${connection.wifiStrength}%`);
  return <p className="text-xs text-muted-foreground">Last reported connection: {parts.join(' · ')} · {formatPhoneReportTime(new Date(connection.observedAt).toISOString())}</p>;
}
